<template>
  <tr>
    <td>
      <select class="form-control form-control-sm" v-model.lazy="signatureType">
        <option value=""></option>
        <option value="tenant">Tenant</option>
        <option value="landlord">Landlord</option>
        <option value="pi">Property Inspector</option>
        <option value="other">Other</option>
      </select>
    </td>
    <td>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model.lazy="signatureName"
      />
    </td>
    <td>
      <input
        type="email"
        class="form-control form-control-sm"
        v-model.lazy="signatureEmail"
      />
    </td>
    <td>
      <input
        type="date"
        class="form-control form-control-sm"
        v-model.lazy="signatureDate"
      />
      <div class="image-preview outline mt-2" v-if="signatureImage">
        <img
          :src="`data:image/jpeg;base64,${signatureImage}`"
          class="mt-2 image"
        />
        <div data-v-8a00acfe="" class="button-group" >
          <i class="fas fa-lg fas fa-copy" @click="copyURL()"></i>
        </div>
      </div>
      <div v-else-if="signatureName" class="image-preview outline mt-2">
        <img
          :src="`data:image/png;base64,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`"
          class="mt-2 image"
        />
        <div class="button-group" >
          <i class="fas fa-lg fas fa-paste" @click.prevent="pasteSignature()"></i>
        </div>
      </div>
    </td>
    <td class="text-right">
      <button
        class="btn btn-sm btn-outline-danger"
        @click="removeSignature(signature)"
        tabindex="-1"
      >
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script lang="ts" setup>
import { ref, computed, inject, defineProps } from "vue";
import { useStore } from "vuex";
import { Signature } from "@/models";
import { useToast } from "vue-toastification";

const props = defineProps<{ signature: Signature }>();
const store = useStore();
const actProperty: any = inject("actProperty");
const toasted = useToast();

const removeSignature = async (signature: Signature) => {
  await store.dispatch("reports/removeSignature", signature);
};

const setSignatureProperty = async (property: string, val: string) => {
  await store.dispatch("reports/setSignatureProperty", {
    signature: props.signature,
    property,
    val,
  });
};

const signatureType = computed({
  get: () => props.signature.type,
  set: (val: string) => setSignatureProperty("type", val),
});

const signatureName = computed({
  get: () => props.signature.name,
  set: (val: string) => setSignatureProperty("name", val),
});

const signatureEmail = computed({
  get: () => props.signature.email,
  set: (val: string) => setSignatureProperty("email", val),
});

const signatureDate = computed({
  get: () => actProperty.dateToLocalTime(props.signature.date),
  set: (val: string) =>
    setSignatureProperty("date", actProperty.datetimeToUTC(val)),
});

// signatureImage doesn't need a setter as it's not expected to change from this component
const signatureImage = computed(() => props.signature.image);

const copyURL = async () => {
  await navigator.clipboard.writeText(signatureImage.value);
  toasted.success("Signature copied");
};

const isBase64 = (base64String:string) => {
  // Create an image object
  const img = new Image();
  
  // Set the source to the base64 string
  img.src = `data:image/jpeg;base64,${base64String}`;
  
  // Check if the image loaded successfully
  return img.complete && img.naturalWidth !== 0;
}
const pasteSignature = async () => {
  const text = await navigator.clipboard.readText();    
  if(text && isBase64(text)) {
    setSignatureProperty("image", text);
    toasted.success("Signature pasted");
  } else {
    toasted.error('Format of the signature is not proper or blank')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.image {
  height: auto;
  max-width: 100%;
  padding: 1em 1em 0;
  width: 100%;
}
.button-group {
    right: .3rem;
    position: absolute;
    bottom: .25rem;
}
.image-preview {
    display: inline-block;
    vertical-align: top;
    position: relative;
    z-index: 0;
    cursor: pointer;
}
.outline {
    border: 1px solid #e2e2e2;
    border-radius: 2px;
}
</style>
